import { useContext, useEffect, useState } from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'
import DashHeader from '../components/dashboard/header/DashHeader'
import DashHome from '../components/dashboard/homeTab/Home'
import DashChatTab from '../components/dashboard/ChatTab/DashChatTab'
import ConnectTab from '../components/dashboard/ConnectTab/ConnectTab'
import NewEvent from '../components/dashboard/ConnectTab/NewEvent/NewEvent'
import ConnectTabMobile from '../components/dashboard/ConnectTab/ConectionTabMobile'
import PersonalCharts from '../components/dashboard/ConnectTab/MainMobile/PersonalCharts'
import MentorCharts from '../components/dashboard/ConnectTab/MainMobile/MentorCharts'
import WelcomeModal from '../utils/WelcomeModal'
import GuestContext from '../contexts/GuestContext'
import Auth from '../utils/AuthModal'
import style from '../components/home/header/Header.module.css'
import { useAuthContext } from '../contexts/AuthContext'
import useWindowWidth from '../hooks/useWindowWidth'
import { UserProvider } from '../contexts/UserContext'
import UploadModal from '../components/dashboard/uploadModal/UploadModal'
import ProfileTab from '../components/dashboard/profileTab/ProfileTab'
import Roadmaps from '../components/dashboard/roadMaps/roadmaps'
import Spotlight from '../components/dashboard/Spotlight'
import SuperUserHeader from '../components/dashboard/SuperUserHeader'
import SuperUserModals from '../components/dashboard/SuperUserModals'
import CareerCompanionPage from '../components/career-companion'
import JobFitCheckPage from '../components/JobFitCheckPage/JobFitCheckPage'
import ActionsPage from '../components/dashboard/ActionsPage/ActionsPage'
const Dashboard = ({
  openReg,
  setOpenReg,
  setOpenAuth,
  openAuth,
  handleAuth,
}) => {
  const [selectedTab, setSelectedTab] = useState('Home')
  const [user, setUser] = useState(null)
  const [superModalPath, setSuperModalPath] = useState('')

  const { guestUser, setGuestUser, openGuestInfo, setOpenGuestInfo } =
    useContext(GuestContext)

  const navigate = useNavigate()
  const location = useLocation()

  const { isAuthenticated, setIsAuthenticated, getCookie, isSuperUser, setIsSuperUser } =
    useAuthContext()

  const innerWidth = useWindowWidth()
  const url = process.env.REACT_APP_API_URL || ''

  const handleSelectTab = (value) => {
    setSelectedTab(value)
    navigate(`/dashboard/${value.toLowerCase()}`)
    if (value === 'Profile') {
      setSelectedTab(value)
      navigate(`/dashboard/${value.toLowerCase()}?id=${user.user.user_id}`)
    }
  }
  useEffect(() => {
    if (isAuthenticated) {
      const token = getCookie('token')
      fetch(`${url}/user/profile`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then((data) => {
          setUser(data)
          // Extract and store isSuperUser from profile data
          if (data && data.user && typeof data.user.isSuperUser !== 'undefined') {
            const isSuperUserValue = data.user.isSuperUser === 1 || data.user.isSuperUser === true
            setIsSuperUser(isSuperUserValue)
            // Also set cookie for persistence
            if (isSuperUserValue) {
              Cookies.set('isSuperUser', 'true')
            } else {
              Cookies.remove('isSuperUser')
            }
          }
        })
        .catch((error) => {
          console.error('There was a problem with the fetch operation:', error)
        })
    }
  }, [isAuthenticated])
  useEffect(() => {
    const shouldReload = sessionStorage.getItem('refreshAfterLogin') === 'true'
    if (location.pathname === '/dashboard/home' && shouldReload) {
      sessionStorage.removeItem('refreshAfterLogin') // prevent loops
      window.location.reload()
    }
  }, [location.pathname])
  useEffect(() => {
    const path = location.pathname.split('/')[2]
    if (path) {
      const capitalizedPath = path.charAt(0).toUpperCase() + path.slice(1)
      if (capitalizedPath !== selectedTab) {
        setSelectedTab(capitalizedPath)
      }
    } else {
      setSelectedTab('Home')
      navigate('/dashboard/home')
    }
  }, [location.pathname, selectedTab, navigate])

  return (
    <div className="dashboard">
      {/* SuperUserHeader hidden for all users */}
      {/* {isAuthenticated && (
        <SuperUserHeader
          superModalPath={superModalPath}
          setSuperModalPath={setSuperModalPath}
        />
      )} */}

      <UserProvider user={user} setUser={setUser}>
        <SuperUserModals
          superModalPath={superModalPath}
          setSuperModalPath={setSuperModalPath}
        />

        <DashHeader
          selectedTab={selectedTab}
          handleSelectTab={handleSelectTab}
          setOpenGuestInfo={setOpenGuestInfo}
          openGuestInfo={openGuestInfo}
          openReg={openReg}
          setOpenReg={setOpenReg}
          openAuth={openAuth}
          setOpenAuth={setOpenAuth}
          handleAuth={handleAuth}
          user={user}
        />
        {guestUser && openGuestInfo && (
          <div
            style={{
              width: 'calc(100vw - 40px)',
              position: 'absolute',
              top: '80px',
              height: 'calc(100vh - 90px)',
              margin: innerWidth > 768 ? '20px' : '10px',
              marginBottom: '0',
              zIndex: '20',
              borderRadius: '10px',
              marginTop: '0',
              overflow: 'scroll',
              background: 'white',
            }}
            className="dashWelcome"
          >
            <WelcomeModal
              setOpenGuestInfo={setOpenGuestInfo}
              openGuestInfo={openGuestInfo}
              setGuestUser={setGuestUser}
              openReg={openReg}
              setOpenReg={setOpenReg}
              openAuth={openAuth}
              setOpenAuth={setOpenAuth}
              handleAuth={handleAuth}
              innerWidth={innerWidth}
            />
          </div>
        )}

        <Routes>
          <Route
            path="home"
            element={
              <DashHome
                selectedTab={selectedTab}
                handleSelectTab={handleSelectTab}
                user={user}
              />
            }
          />
          <Route path="chat" element={<DashChatTab user={user} />} />

          <Route path="spotlight" element={<Spotlight />} />

          <Route
            path="connect"
            element={
              innerWidth > 768 ? (
                <ConnectTab user={user} setSelectedTab={setSelectedTab} />
              ) : (
                <ConnectTabMobile user={user} setSelectedTab={setSelectedTab} />
              )
            }
          />
          <Route
            path="connect/create-new-event"
            element={<NewEvent user={user} setSelectedTab={setSelectedTab} />}
          />
          <Route
            path="connect/personal-chart"
            element={
              <PersonalCharts user={user} setSelectedTab={setSelectedTab} />
            }
          />
          <Route
            path="connect/mentor-chart"
            element={<MentorCharts user={user} setSelectedTab={setSelectedTab} />}
          />
          <Route path="/upload" element={<UploadModal />} />
          <Route path="/profile" element={<ProfileTab user={user} />} />
          <Route path="/roadmaps" element={<Roadmaps />} />
          <Route path="/career-companion" element={<CareerCompanionPage />} />
          <Route path="/job-fit-check/:jobId" element={<JobFitCheckPage />} />
          <Route path="/actions" element={<ActionsPage />} />

          <Route
            path="*"
            element={
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                Coming soon
              </div>
            }
          />
        </Routes>
        {openReg && (
          <div className={style.form}>
            <Auth
              handleAuth={handleAuth}
              openReg={openReg}
              openAuth={openAuth}
              setOpenAuth={setOpenAuth}
            />
          </div>
        )}
      </UserProvider>
    </div>
  )
}

export default Dashboard
